import FeatureLayer from "@arcgis/core/layers/FeatureLayer";

// ** found updated url by going to coast.noaa.gov and searching for USGS Sediment Texture
const url = "https://coast.noaa.gov/arcgis/rest/services/Hosted/SedimentTexture/FeatureServer/0";

// ** found portal item by searching https://marinecadastre.gov/ and clicking on "open in ARCGIS online"
const portalId = '82cc631e0a0646879bd02895c9f61286'

export const layer = new FeatureLayer({
  url,
  title: "USGS Sediment Texture",
  popupTemplate: {
    title: "{CLASSIFICA}",
    content: [
      {
        type: "text",
        text: `<a href=${url}>More Info</a>`,
      },
      {
        type: "fields",
        fieldInfos: [
          { fieldName: "DEPTH_M", label: "Depth in meters" },
          { fieldName: "GRAVEL_PCT", label: "Percent Gravel" },
          { fieldName: "SAND_PCT", label: "Percent Sand" },
          { fieldName: "SILT_PCT", label: "Percent Silt" },
          { fieldName: "CLAY_PCT", label: "Percent Clay" },
        ],
      },
    ],
  },
  visible: true,
  layerDescription: "USGS Sediment Texture",
  mapService: url,
  authoritiveSource: `https://marinecadastre.gov/`,
});

export const sediment = {layerId: 'sediment', type: 'layer', item: layer, meta: layer}
